import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Container, Nav, NavItem } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './Header.css';

const Navlinks = [
    {
        title: "Home",
        href: "/"
    },
    {
        title: "About Us",
        href: "/about"
    },
    {
        title: "Blog",
        href: "/blog"
    },
    {
        title: "Videos",
        href: "/videos"
    },
    {
        title: "Contact Us",
        href: "/contact"
    },
]

function Header() {
  return (
    <Navbar expand="md" className='navbar-main mx-auto'>
    <Container className='nav-container' >
      <Navbar.Brand href="/" className='logo'>
        <img src="https://res.cloudinary.com/ogochi23/image/upload/c_scale,h_48,q_auto:best,w_48/v1684594142/ANG/ANG-logo.webp" alt='logo' style={{width:"48", height:"48"}}/>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="menuToggle"/>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className='nav-gap'>
          {Navlinks.map((link) => (
            <NavItem key={link.title} className='nav-house'>
              <NavLink
                to={link.href}
                className={({
                  isActive 
                }) => [
                  "text-center",
                  isActive ? " active-link " : " nav-plain",
                ].join(" ")}
              >
                {link.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <Nav>
            <NavItem className='contact1'>
                <Nav.Link href='/contact' className='contact1'>
                    Contact
                </Nav.Link>
            </NavItem>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
  );
};

export default Header;